import { render } from "./JoinBenefit.vue?vue&type=template&id=25d35fba&ts=true"
import script from "./JoinBenefit.vue?vue&type=script&lang=ts"
export * from "./JoinBenefit.vue?vue&type=script&lang=ts"

import "./JoinBenefit.vue?vue&type=style&index=0&id=25d35fba&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__